import { Link, Navigate } from 'react-router-dom';
import PdfViewer from './PdfViewer';
import { useNavigate } from "react-router-dom";

// import './App.css';

function Home() {
  const navigate = useNavigate();

  return (
    <div
      className="container-fluid border border-danger position-relative"
      style={{
        minHeight: "100vh",
        backgroundImage: `url("/Assets/bg.jpg")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >

      <div className='col-sm-12 d-flex justify-content-between p-1 align-items-center flex-wrap'>
        <div className="col-sm-4 col-md-3 p-2 bg-light rounded m-3">
          <img class="img-fluid float-start" src="https://edge.sitecorecloud.io/nurnbergmes0e18-nmmultisite6e34-prod50da-6065/media/Project/NuernbergMesse/BIOFACH/BIOFACH/DefaultImages/fair_logo.svg?iar=0" alt="" />
        </div>
        <div className="col-sm-4 col-md-3 p-2 bg-light rounded m-3">
          <img className="img-fluid float-end" src="/Assets/Ministry-logo.png" alt="" />
        </div>
      </div>

      <div className="row flex-column " style={{ marginTop: "12vw" }} >
        <div className="col-sm-6  mx-auto mb-4">
          <button onClick={() => window.location.href = '/Assets/PDF/biofach_directory.pdf'} className="btn btn-block btn-info text-light rounded-pill w-100" style={{ fontSize: "22px", fontWeight: 700 }} >Exhibitors Directory</button>
          {/* <button
            onClick={() => navigate("/pdf/biofach_directory")}
            className="btn btn-block btn-info text-light rounded-pill w-100"
            style={{ fontSize: "22px", fontWeight: 700 }}
          >
            Exhibitors Directory
          </button> */}

        </div>

        <div className="col-sm-6  mx-auto m-4">
          <button
            onClick={() => window.location.href = '/Assets/PDF/Recipe_Book.pdf'}
            // onClick={() => navigate("/pdf/Recipe_Book")}
            className="btn btn-block btn-info text-light rounded-pill w-100 p-2" style={{ fontSize: "22px", fontWeight: 700 }}>Recepie Book</button>
        </div>
        <div className="col-sm-6 m-4 mx-auto">
          <button
            onClick={() => window.location.href = '/Assets/PDF/India_Brochure.pdf'}
            // onClick={() => navigate("/pdf/India_Brochure")}
            className="btn btn-block btn-info text-light rounded-pill w-100" style={{ fontSize: "22px", fontWeight: 700 }} >Brochure</button>
        </div>
        <div className="col-sm-6 m-4 mx-auto">
          <button
            onClick={() => window.location.href = '/Assets/PDF/biofach_layout.pdf'}
            // onClick={() => navigate("/pdf/biofach_layout")}
            className="btn btn-block btn-info text-light rounded-pill w-100" style={{ fontSize: "22px", fontWeight: 700 }} >Biofach Layout</button>
        </div>
      </div>

    </div>

  );
}

export default Home;
